// config.js

const hostUrl = 'https://samiot.com/api';
//const hostUrl = 'http://127.0.0.1:8000';
const apiUrl = `${hostUrl}/api`;


export { hostUrl, apiUrl };
